export default {
  site: {
    title: 'הדף בעיון',
    title_mishna: 'משנה בעיון',
    subtitle: 'זרעים וטהרות',
    tagline: 'עיקרי ראשונים ואחרונים על כל השס',
    metaWithName: '{{name}} - הדף בעיון',
    metaWithoutName: 'הדף בעיון',
    metaTorahWithName: '{{name}} - תורה - הדף בעיון',
    metaTorahWithoutName: 'תורה - הדף בעיון',
    metaMishnahWithName: '{{name}} - משנה - הדף בעיון',
    metaMishnahWithoutName: 'משנה - הדף בעיון',
    aboutUs: 'אודות',
    titleWithSubtitle: 'שיעורי הדף בעיון',
  },
  more: 'עוד',
  live: 'שידור חי',
  login: 'כניסה',
  register: 'הרשמה',
  downloadPdf: 'PDF הורד בקובץ ',
  follow: 'עקוב',
  unfollow: 'הפסק לעקוב',
  previous: 'הקודם',
  next: 'הבא',
  viewAll: 'הצג הכל',
  topic: 'נושא',
  topics: 'נושאים',
  search: 'חיפוש',
  speaker: 'מגיד שיעורדובר',
  speakers: 'מגידי שיעור',
  masechta: 'מסכת',
  daf: 'דף',
  todayDaf: 'הדף היומי',
  sortBy: 'מיין לפי',
  jumpToDaf: 'דלג לדף',
  jumpToChapter: 'דלג לפרק',
  jumpToMishna: 'דלג למשנה',
  filterBy: 'סנן לפי',
  dedicatedBy: 'מוקדש על ידי: {{ name }}',
  sponsoredBy: 'נתרם על ידי',
  sponsoredByMessageShas: 'הדף הזה נתרמה על ידי {{ names }}',
  sponsoredByMessageMishna: 'משנה זו נתרמה על ידי {{ names }}',
  dedicatedTo: 'מוקדש ל',
  showDaf: 'הצג את הדף',
  name: 'שם',
  send: 'שלח',
  date: 'תאריך',
  time: 'שעהזמן',
  length: 'משךאורך',
  mobile: 'סלולרינייד',
  message: 'הודעה',
  length: 'משךאורך',
  actions: 'פעולות',
  title: 'כותרת',
  months: 'חודשיחודשים',
  daily: 'יומי',
  never: 'אף פעם',
  or: 'או',
  message: 'הודעה',
  fullName: 'שם מלא',
  phoneNumber: 'מספר טלפון',
  address1: 'כתובת 1',
  address2: 'כתובת 2',
  city: 'עיר',
  podcasts: 'פודקאסטים',
  haskamos: 'הסכמות',
  torahResources: 'משאבי תורה',
  torahShiurim: 'שיעורי תורה',
  zipPostal: 'מיקוד  דואר',
  stateProvinceRegion: 'מדינה / חבל ארץ / איזור',
  email: 'דואר אלקטרוני',
  filterShiur: 'סנן שיעורים',
  magidShiur: 'מגיד שיעור',
  magideiShiur: 'מגידי שיעור',
  shiur: 'שיעור',
  shiurim: 'שיעורים',
  contact: 'צור קשר',
  donate: 'תרום',
  comment: 'הגב',
  delete: 'מחק',
  playOrDownload: 'הפעל / הורד',
  masechtos: 'מסכתות',
  selectMasechta: 'בחר מסכתא',
  hadafBeiyunShiur: 'מגידי שיעורים של הדף בעיון',
  allMagideiShiur: 'כל מגידי השיעורים',
  mishnaMagideiShiur: 'משנה בעיון מגידי שיעור',
  mishnaIlluminatedShiurimSeries: 'משנה בעיון מגידי שיעור',

  searchShiurim: 'חפש שיעורים',
  filterMagidShiur: 'סנן מגידי שיעורים',
  filterByMagidShiur: 'סנן לפי מגידי שיעורים',
  filterTopic: 'סנן נושא',
  filterByTopic: 'סנן לפי נושא',
  filterByTopicCategory: 'סנן לפי קטגוריה',
  filterBySubTopic: 'סנן לפי תת נושא',
  removeSavedShiurim: 'הסר שיעורים שמורים',
  saveShiurim: 'שמור שיעורים',

  noTopicsMatch: 'אין נושאים התואמים: {{ query }}',
  records: 'Records: {{ count }}',
  askResendEmailInvite: 'האם ברצונך לשלוח שוב דוא"ל לאימות חשבון?',
  thoughtsOnShiur: 'את המחשבות שלך על השיעור הזה',
  privacy_policy: 'מדיניות פרטיות',
  terms_and_conditions: 'תנאים',
  topicCategories: 'קטגוריות',
  allTopics: 'כל הנושאים',

  mishnaShiurTitle: '{{ masechta }} פרק {{ chapter }} משנה {{ mishna }}',
  perek: 'פרק',
  mishna: 'משנה',
  verificationCode: 'קוד אימות',
  verify: 'תאשר',
  goBack: 'תחזור',
  cancelVerification: 'בטל את האימות',
  submitCode: 'שלח קוד',
  update: 'עדכון',
  saved: 'שמור',
  pleaseEnterVerificationCode: 'אנא הזן את קוד האימות שנשלח לטלפון שלך',
  requestPhoneCall: 'בקש שיחת טלפון',
  resendCode: 'שלח קוד שוב',
  errorWhileVerifyingCode: 'שגיאה בעת אימות הקוד. בבקשה נסה שוב.',
  phoneFieldDescription: 'אסור להשתמש באלפבית, מקפים ותווים מיוחדים אחרים.',
  registerPhoneFieldDescription: 'אנא הקפד להזין את מספר הטלפון הנכון. תצטרך לאמת את הטלפון שלך כדי להירשם.'
};

